// Exports
export default {
	"CopyNumberButton": "CopyNumberButton_YfPul",
	"CopyIcon": "CopyIcon_0LRX8",
	"OkIcon": "OkIcon_w9jb-",
	"CopyNumberButton_Toggled": "CopyNumberButton_Toggled_K3HHs"
};
